export enum ServiceLLMStatus {
  pending = 'pending',
  compleat = 'compleat',
  canceled = 'canceled',
  error = 'error',
}
